import {Box, Divider, Modal, ModalProps, ScrollArea, Tabs, useMantineTheme} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {MessageEntity, ObjectDocumentAssocEntity, Supplemental} from "@ots-frontend/ots-data";
import {Empty} from "../../../empty/Empty/Empty";
import {HasAccess} from "../../../auth/HasAccess/HasAccess";
import {Comment, makeCommentProps} from "../../../comment/Comment/Comment";
import {useCallback, useMemo, useState} from "react";
import {ImageCarousel} from "../../../carousel/ImageCarousel/ImageCarousel";
import {DocumentTable} from "../../../table/DocumentTable/DocumentTable";

export interface Extras {
  messages?: MessageEntity[],
  supplementals?: Supplemental[]
}

export interface ExtrasModalProps extends Omit<ModalProps, 'transitionProps' | 'scrollAreaComponent'> {
  extras: Extras
  showEmpty?: boolean
}

export const ExtrasModal = (props: ExtrasModalProps) => {
  const {
    extras,
    showEmpty = true,
    title,
    ...rest
  } = props;

  const {messages, supplementals} = extras;

  const [images, setImages] = useState([])

  const {t} = useTranslation(["common"]);
  const appTheme = useMantineTheme()

  const onTabChange = useCallback((tab: string) => {
    if (tab === "pics") {
      setImages(supplementals?.filter(s => s.supplementalGroup === "IMAGE")?.map((p) => ({
        src: p.url,
      })))
    }
  }, [supplementals]);

  const docs = useMemo(() => {
    return supplementals?.filter(s => s.supplementalGroup === "DOCUMENT")?.map(ObjectDocumentAssocEntity.from)
  }, [supplementals])

  return (
    <Modal
      {...rest}
      title={title ? title : "Extras"}
      scrollAreaComponent={ScrollArea.Autosize}
      withinPortal={true}>
      <Tabs defaultValue="messages" onTabChange={onTabChange}>
        <Tabs.List>
          <Tabs.Tab value="messages">Comments</Tabs.Tab>
          <Tabs.Tab value="pics">Pictures</Tabs.Tab>
          <Tabs.Tab value="docs">Documents</Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value="messages">
          <Box h={600}>
            {(showEmpty && (!messages || messages.length === 0)) &&
              <Empty
                maw={400}
                h={100}
                mx="auto"
                message={"No Comments"}
                action={
                  <HasAccess permissions={["edit"]}>
                    {/*{onAddComment &&*/}
                    {/*  <Button onClick={() => onAddComment()}>*/}
                    {/*    {t("common.action.add.comment", "Add Comment")}*/}
                    {/*  </Button>*/}
                    {/*}*/}
                  </HasAccess>
                }/>
            }
            {messages &&
              <>
                {messages.map((m, i) => {
                  return (
                    <>
                      <Comment {...makeCommentProps(m)} p="md"/>
                      {(i !== messages.length - 1) &&
                        <Divider variant="dotted"/>
                      }
                    </>
                  )
                })}
              </>
            }
          </Box>
        </Tabs.Panel>

        <Tabs.Panel value="pics">
          <Box h={600}>
            {(showEmpty && (!images || images.length === 0)) &&
              <Empty
                maw={400}
                h={100}
                mx="auto"
                message={"No Images"}
                action={
                  <HasAccess permissions={["edit"]}>
                    {/*{onAddClick &&*/}
                    {/*  <Button onClick={() => onAddClick()}>*/}
                    {/*    {t("common.action.add.image", "Add Image")}*/}
                    {/*  </Button>*/}
                    {/*}*/}
                  </HasAccess>
                }/>
            }
            {images &&
              <>
                {images.length > 0 &&
                  <ImageCarousel
                    m="md"
                    withIndicators={true}
                    align={"center"}
                    loop={true}
                    styles={{
                      indicator: {
                        marginBottom: "8px",
                        backgroundColor: appTheme.fn.lighten(appTheme.fn.primaryColor(), 0.5),
                        '&[data-active]': {
                          backgroundColor: appTheme.fn.primaryColor(),
                        },
                      },
                    }}
                    data={images}/>
                }
              </>
            }
          </Box>
        </Tabs.Panel>

        <Tabs.Panel value="docs">
          <Box h={600}>
            {(showEmpty && (!docs || docs.length === 0)) &&
              <Empty
                maw={400}
                h={100}
                mx="auto"
                message={"No Documents"}
                action={
                  <HasAccess permissions={["edit"]}>
                    {/*{onAddClick &&*/}
                    {/*  <Button onClick={() => onAddClick()}>*/}
                    {/*    {t("common.action.add.image", "Add Image")}*/}
                    {/*  </Button>*/}
                    {/*}*/}
                  </HasAccess>
                }/>
            }
            {docs &&
              <>
                <DocumentTable documents={docs}/>
              </>
            }
          </Box>
        </Tabs.Panel>
      </Tabs>
    </Modal>
  );
};
